export default __webpack_public_path__ + "static/media/caret_down_gray.01091ca1.svg";